module.exports = __webpack_public_path__ + "4e288fc363516242d938b822d49d7e14.png";